<div class="container" *ngIf="PageLoading">
      <div>
        <div class="text-center pt-5 pb-5">
          <div class="loader loader--style8" title="7">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
              </rect>
              <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
              </rect>
              <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
              </rect>
            </svg>
          </div>
        </div>  
      </div> 
</div>

<div class="container" *ngIf="!PageLoading">
  <div class=" pb-2">
    <app-breadcrumb 
      returnAction="/dashboard" 
      [breadcrumbs]="[
          { label: 'Whatsapp Business' } 
      ]"
    >
    </app-breadcrumb>   
  </div>

                <div class="col-12 mb-3">
                  <div class="cd-title">
                    Whatsapp Business
                  </div>
                </div>
                <div class="pb-4">
                  <div class="card border-0 mb-3">

                    <div class="container filterdiv" style="padding: 0px; margin: 0px;">
                        <div *ngIf="isSubsribed">
                            <div class="formMessaging">
                              <div class="" *ngIf="safeUrl">
                                <iframe 
                                  id="chat-frame"
                                  [src]="safeUrl"
                                  style="width: 100%; border: none; min-height: 80vh;display: block;"
                                ></iframe>
                              </div>
                            </div>
                        </div>
                        <div *ngIf="!isSubsribed" class="container p-5 my-5">
                          <div>
                              <div style="text-align: center;" class="py-5 my-5">
                                <div  style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 1); display: flex; align-items: center; justify-content: center; border-radius: 4px; z-index: 10;">
                                  <div>
                                    <p class="cdc1 fw-bold mb-0">Anda belum berlangganan WhatsApp Business</p>
                                    <p><small  class="cdc1">Silakan berlangganan untuk menggunakan fitur WhatsApp Business</small></p>
                                    <button type="button" class="btn btn-primary fhbcyan" (click)="gotoSubscription()">Subscribe</button>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                    </div>

                  </div>

                </div>

</div>

